/* tslint:disable */
/* eslint-disable */
/**
 * documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetSchedulerStatus200Response,
  SearchTableQuery,
  StorageWithIndexCount,
  TableResultSolrSearchResult,
} from '../models/index';

export interface IndexApiClearIndexRequest {
    tenant: string;
    path: string;
}

export interface IndexApiGetSchedulerStatusRequest {
    tenant: string;
}

export interface IndexApiRenewIndexRequest {
    tenant: string;
    path: string;
}

export interface IndexApiSearchRequest {
    tenant: string;
    searchTableQuery: SearchTableQuery;
}

/**
 * 
 */
export class IndexApi extends runtime.BaseAPI {

    /**
     */
    async clearIndexRaw(requestParameters: IndexApiClearIndexRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageWithIndexCount>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling clearIndex().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling clearIndex().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/index/clear`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async clearIndex(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageWithIndexCount> {
        const response = await this.clearIndexRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSchedulerStatusRaw(requestParameters: IndexApiGetSchedulerStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSchedulerStatus200Response>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling getSchedulerStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/index/full/status`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSchedulerStatus(tenant: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSchedulerStatus200Response> {
        const response = await this.getSchedulerStatusRaw({ tenant: tenant }, initOverrides);
        return await response.value();
    }

    /**
     */
    async renewIndexRaw(requestParameters: IndexApiRenewIndexRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageWithIndexCount>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling renewIndex().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling renewIndex().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/index/renew`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async renewIndex(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageWithIndexCount> {
        const response = await this.renewIndexRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchRaw(requestParameters: IndexApiSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TableResultSolrSearchResult>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling search().'
            );
        }

        if (requestParameters['searchTableQuery'] == null) {
            throw new runtime.RequiredError(
                'searchTableQuery',
                'Required parameter "searchTableQuery" was null or undefined when calling search().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/index/search`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['searchTableQuery'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async search(tenant: string, searchTableQuery: SearchTableQuery, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TableResultSolrSearchResult> {
        const response = await this.searchRaw({ tenant: tenant, searchTableQuery: searchTableQuery }, initOverrides);
        return await response.value();
    }

}
